import {
  NewProgressStepModal as LibProgressStepModal,
  NewProgressStepModalProps as LibProgressStepModalProps,
  NewProgressStepModalKind as LibProgressStepModalKind,
  ProgressModalStep as LibProgressModalStep,
  useProgressStepModal,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type ProgressStepModalProps<TStep> = Omit<
  LibProgressStepModalProps<TStep>,
  "languageTexts"
> & { nextButtonText?: string };
export type ProgressStepModalKind = LibProgressStepModalKind;
export type ProgressStepModalStep<TStepType extends string> = LibProgressModalStep<TStepType>;

export function ProgressStepModal<TStep>(props: ProgressStepModalProps<TStep>) {
  const t = useT();

  return (
    <LibProgressStepModal
      {...props}
      languageTexts={{
        cancel: t("general.actions.cancel"),
        close: t("general.actions.close"),
        previous: t("general.actions.previous"),
        next: props.nextButtonText ?? t("general.actions.next"),
      }}
    />
  );
}

export { useProgressStepModal };
